function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:#b7d6d6;}.cls-2{stroke:#b7d6d6;stroke-width:0.25px;}.cls-2,.cls-3,.cls-4{stroke-miterlimit:10;}.cls-3,.cls-4{fill:none;stroke:#1d3541;}.cls-3{stroke-width:3px;}.cls-4{stroke-width:3.5px;}.cls-5{fill:#1d3541;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "PICA"
}, /*#__PURE__*/React.createElement("polygon", {
  className: "cls-1",
  points: "69.24 59.54 46.13 13.48 23.21 59.54 69.24 59.54"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-2",
  d: "M66.72,61.91H14.51l26-52.24ZM19.85,58.6H61.36L40.53,17.07Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M17.72,64.23A2.73,2.73,0,1,1,15,61.5,2.73,2.73,0,0,1,17.72,64.23Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-3",
  d: "M36.62,39.58a2.73,2.73,0,1,1-2.73-2.73A2.73,2.73,0,0,1,36.62,39.58Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-4",
  d: "M37.5,39.79c4.67,0,8.45,2.83,8.45,6.33s-3.78,6.33-8.45,6.33v10.4H61.42l-22.6-45-22.42,45"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M81.15,17.22H93.72a37.83,37.83,0,0,1,9.78,1,11.48,11.48,0,0,1,6.33,4.57,14.07,14.07,0,0,1,2.57,8.5,14.33,14.33,0,0,1-2.09,7.85,11.78,11.78,0,0,1-5.6,4.73q-3.51,1.45-10.8,1.46H89.55v18h-8.4Zm8.4,5.92v16.1h4.17q5.58,0,7.72-1.9t2.14-6.15A8.7,8.7,0,0,0,102.17,26a5.8,5.8,0,0,0-3.11-2.43,22.14,22.14,0,0,0-5.34-.46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M121.46,17.22h8.41V63.39h-8.41Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M167.8,47.86l7.74,1q-2.37,15.39-16.61,15.39-9.26,0-13.79-6.46t-4.53-17.28q0-11.67,4.79-17.89t13.83-6.22q14,0,16.39,15.76l-7.82,1q-1.26-10.48-8.53-10.48-9.74,0-9.73,18.23,0,17,9.73,17a6.78,6.78,0,0,0,5.81-2.59A17.44,17.44,0,0,0,167.8,47.86Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-5",
  d: "M194.92,17.22h9.42L218,63.39h-8.51l-3.19-11.57H191.39l-3.16,11.57h-8Zm9.7,28.58L198.8,24.66,193,45.8Z"
}));

function SvgLogoWide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 228.85 75.37",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoWide);
export default __webpack_public_path__ + "static/media/logo-wide.aff27a0c.svg";
export { ForwardRef as ReactComponent };